import { Component, OnInit } from '@angular/core';
import { PworkflowComponent } from '../index';
import { ServiceInterface } from 'services/service.interface';
import { config } from '../../../../config';
import { GoogleAnalyticsEventsService } from 'services/google.analytics.events.service';
import { base64Utility } from '../../../../utils/base64Utility';
import * as moment from 'moment/moment';

declare var $: any;
@Component({
  selector: 'result',
  templateUrl: 'result.component.html'
})

export class ResultComponent implements OnInit {
  formClass: string = "";
  resultData = [];
  specificCollege = [];
  error: string = "";
  emailData = [];
  showMessage: boolean = false;
  successMessage: boolean = false;
  cname: string;
  totalResult: number;
  loading: boolean = false;
  showMore: boolean = true;
  messageInfo: string;
  serverUrl = config.serverUrl[process.env.NODE_ENV];
  noList: boolean = true;
  showResult: boolean = false;
  spinner: boolean = false;
  envelope: boolean = true;
  emptyPassedCollege: boolean = true;
  sliceNumber: number = 0;
  staticlist = [];
  topData = [];
  encrypt = new base64Utility();
  sbucketLists = [];
  trackingName = "Request Info-2";
  //listcheckval: any[];
  veteranPhone: string;
  checkPhone: string;
  saving: boolean = false;
  phoneErrorMessage: boolean = false;
  PhoneSuccessMessage: boolean = false;
  checkedColleges = [];
  // tcpaValid = 
  snhuChecked: boolean = false;
  formData = {
    name: '',
    email: '',
    phone: '',
    trustedform_cert_url: '',
    trustedform_ping_url: '',
    advertiser_name: ''

    //tcpa_opt_in: false,
  };

  constructor(private _services: ServiceInterface, public _parent: PworkflowComponent, public googleAnalyticsEventsService: GoogleAnalyticsEventsService) { }

  async ngOnInit() {
    setTimeout(() => {
      $(function () {
        $(".bluecircle").percircle();
      });
    }, 2000);
    if(this._parent.campaignName){
      this.trackingName = this._parent.campaignName+" - Request Info";
    }
    
    this._parent.model.pageNumber = 0;
    this.sliceNumber = 3;
    //this._parent.model.first_name = "shivaram";
    //this._parent.model.last_name = "prajapati";
    //this._parent.model.military_branch = "1";
    //this._parent.model.uuid="268266-F07099-A6F101-68FD";
    /*this._parent.model.area_focus_ids = "140903";
    this._parent.model.study_state_values = "AZ";
    //this._parent.model.study_type = "Online";*/
    //this.staticlist = await  this._services.getList('/college/basicinfo/1913,3449');
    this.resultData = await this._services.post('/search/matchdata', this._parent.model);
    for(let col of this.resultData) {
      for(let rcol of this.resultData) {
        if(rcol.parentCollegeId == col.collegeId && !col.parentCollegeId) {
          let index = this.resultData.indexOf(col);
          this.resultData.splice(index,1);
        }
      }
    }
    this.totalResult = this.resultData.length;
  //  this.resultData = this.resultData && this.resultData.sort(function (a, b) { return b.percentMatch - a.percentMatch });
    // Logic for 5 non partner and 10 partner school to pre checked
    let nonPartnerCount = 0;
    let partnerCount = 0;
    for(let i = 0; i < this.resultData.length; i++){
      if(this.resultData[i]["accessLevel"] != "Patriot"  && this.resultData[i]["collegeContact"]){
        this.resultData[i]["checkNonPartner"]=true;
        //nonPartnerCount++;
      }else{
        this.resultData[i]["checkNonPartner"]=false;
      }

      if(this.resultData[i]["accessLevel"] == "Patriot" && this.resultData[i]["collegeContact"]){
        this.resultData[i]["checkPartner"]=true;
      }else{
        this.resultData[i]["checkPartner"]=false;
      }
    }
    if (this._parent.model.passedIn_college_id) {
      this.emptyPassedCollege = false;
      let data = this.resultData && this.resultData.splice(this.resultData && this.resultData.findIndex(item => item.collegeId == this._parent.model.passedIn_college_id), 1)
      this.topData.unshift(data[0]);
    }
    //this._parent.model.checkCollegeInfo = "";
    //let total = await  this._services.post('/search/emaildata',this._parent.model);
    this.showResult = true;
    if (this.resultData.length <= 3) {
      this.showMore = false;
    }
    if (this.resultData && this.resultData.length > 0) {
      this.noList = false;
    }
    this.sbucketLists =  await this._services.get('/student/secondary/bucket/'+this._parent.model.uuid);
    this.veteranPhone = await this._services.get('/student/phonenumber/'+this._parent.model.uuid);
    //console.log("Data:",this.resultData);
  }

  async loadMoreData() {
    setTimeout(() => {
      $(function () {
        $(".bluecircle").percircle();
      });
    }, 1000);
    this.showMore = false;
    this.loading = true;
    this._parent.model.pageNumber = this._parent.model.pageNumber + 1;
    this.resultData = await this._services.post('/search/matchdata', this._parent.model);
    this.sliceNumber = this.resultData.length;
  //  this.resultData = this.resultData.sort(function (a, b) { return b.percentMatch - a.percentMatch });
    // Logic for 5 non partner and 10 partner school to pre checked
  // let nonPartnerCount = 0;
   // let partnerCount = 0;
    for(let i = 0; i < this.resultData.length; i++){
      if(this.resultData[i]["accessLevel"] != "Patriot"){
        this.resultData[i]["checkNonPartner"]=true;
        //nonPartnerCount++;
      }else{
        this.resultData[i]["checkNonPartner"]=false;
      }

      if(this.resultData[i]["accessLevel"] == "Patriot" ){
        this.resultData[i]["checkPartner"]=true;
       // partnerCount++;
      }else{
        this.resultData[i]["checkPartner"]=false;
      }
    }
    //console.log("DD:",this.resultData);
    if (this._parent.model.passedIn_college_id) {
      this.resultData && this.resultData.splice(this.resultData && this.resultData.findIndex(item => item.collegeId == this._parent.model.passedIn_college_id), 1)
    }
    for(let col of this.resultData) {
      for(let rcol of this.resultData) {
        if(rcol.parentCollegeId == col.collegeId && !col.parentCollegeId) {
          let index = this.resultData.indexOf(col);
          this.resultData.splice(index,1);
        }
      }
    }
    this.totalResult = this.resultData.length;
    this.loading = false;
    //this.resultData.push.apply(this.resultData,moreData);
  }

  async requestInfo() {
    //this.googleAnalyticsEventsService.emitEvent(this.trackingName, this.trackingName, this.trackingName, 6);
    let response = "";
    let check = 0;
    let UnsendColl = "";
    // for static college list
    var thisel = this;
    /*var staticcheck = $(".chk-static-college:checked");
    staticcheck.map(function(index,el){
      for(var i=0;i<thisel.staticlist.length;i++){
        if(thisel.staticlist[i]['id'] == $(el).attr("value")){
          var cname = thisel.staticlist[i]['college_name'];
          let firstname = thisel._parent.model.first_name;
          let lastname = thisel._parent.model.last_name;
          let messagedata = cname+",<br><br>Hi my name is "+firstname+" "+lastname+". I am very interested in what "+cname+" has to offer, and I would love to speak with someone to learn more. Does "+cname+" have a Veteran Affairs office on campus? Could you tell me what types of resources your campus makes available to military-connected students? Any insight would be greatly appreciated.<br><br>Thank you.<br><br>"+firstname;
          
          let emaildata = {
            'studentId' : thisel._parent.model.uuid,
            'collegeId' : thisel.staticlist[i]['id'],
            'messageId' : "",
            'replyMessage' : messagedata,
            'collegeEmail' : thisel.staticlist[i]['contact_email'],
            'attachment' : "",
            'recipient' : "COLLEGE",
            'responder' : "USER",
            'type' : "connect"
          }
          thisel._services.post('/student/replymessage',emaildata);
        }
      }
    })*/
    // for search college list
    var listcheck = $(".chk-college:checked");
    var listcheckval = [];
    listcheck.map(function (index, el) {
      listcheckval.push($(el).attr("value"));
    })
    if(listcheckval.length > 15){
      alert("You cannot contact more than 15 Schools.");
    } else if(listcheckval.length > 0){
      this.checkedColleges = listcheckval;
      const checkedPhoneColleges = this.resultData
      .filter((school) => (this.checkedColleges.indexOf(school.collegeId.toString()) > -1 && school.phoneRequired == "yes"))
      .map((school) => school.collegeId);
      this.snhuChecked = this.checkedColleges.some((college) => college == '3755');//need to see if it is cheked or not
      const snhuCheckedandDisplayed = this.checkedColleges.slice(0, this.sliceNumber).some((school) => school == 3755);
      if(this.snhuChecked && snhuCheckedandDisplayed) {
        $("#phoneNumberMessageModal").modal('toggle');
        this.loadTrustedForm();
      } else {
        if(checkedPhoneColleges.length > 0 && !this.veteranPhone){
          $("#phoneNumberMessageModal").modal('toggle');
        }else{
          this.checkPhone = "all";
          this.sendRequestInfoCollege();
        }
      }

    }else{
      alert("Please check at least one school or click Skip for Now.")
    }
    //console.log("Uc:",uncheckval);
    //console.log("EM:",this.emailData);
  }

  clickSubmit(valid) {
    if (valid) {
      this.messagesubmit();
    } else {
      this.formClass = "validate";
    }
  }

  skipNow() {
    //this.googleAnalyticsEventsService.emitEvent("Skip-2", "Skip-2", "Skip-2", 5);
    window.location.href = this.serverUrl + "/login?uid=" + this._parent.model.uuid;
  }

  collegeChecked(collegeId) {
    return this.checkedColleges.some(school => school === collegeId.toString())
  }

  async messagesubmit() {
    //this.googleAnalyticsEventsService.emitEvent("resultCategory", "resultAction", "resultInformation", 5);
    //console.log("Total:",this.emailData.length);
    let messageinfo = $('#student-message').val();
    let response = "";
    let check = 0;
    let UnsendColl = "";

    for (var i = 0; i < this.emailData.length; i++) {
      this.cname = this.emailData[i]['college_name'];
      let messagedata = messageinfo.replace('CollegeName', this.cname);
      let emaildata = {
        'to': this.emailData[i]['contact_email'],
        'message': messagedata
      }
      this.showMessage = true;
      response = await this._services.post('/search/send/message', emaildata);
      if (response == "success") {
        check++;
      } else {
        UnsendColl = UnsendColl + this.cname + ",";
      }
    }
    this.showMessage = false;
    this.successMessage = true;
    if (check == this.emailData.length) {
      this.messageInfo = "Message Successfully sent to All Colleges."
     window.location.href = this.serverUrl + "/login?uid=" + this._parent.model.uuid;
    } else {
      this.messageInfo = "Message Unable to sent to " + UnsendColl.slice(0, -1);
      let unmessage = "Unable to send message to following colleges </br> " + UnsendColl.slice(0, -1);
      let unemaildata = {
        'to': "garrett@hfalliance.com",
        'message': unmessage
      }
      await this._services.post('/search/send/message', unemaildata);
      window.location.href = this.serverUrl + "/login?uid=" + this._parent.model.uuid;
    }
    // console.log("RR:", UnsendColl.slice(0, -1));
  }

  async cannedMessage() {
    var cannedMsg = $('#canned-messages').val();
    var messageToSend = '';
    var branchAndRank = '';
    //var collegeName = this.collegename;

    var studentName = "";
    var branch = "";
    var bdata = "";

    if (cannedMsg != "") {
      studentName = this._parent.model.first_name + " " + this._parent.model.last_name;

      if (this._parent.model.military_branch != "" && this._parent.model.military_branch != null) {
        bdata = await this._services.get('/branch/' + this._parent.model.military_branch);
        branch = bdata[0]['branch_full_name'];
      }

      if (branch) {
        branchAndRank = ' and I am a ' + branch;
      } else {
        branchAndRank = '';
      }
      messageToSend += "My name is " + studentName + branchAndRank + ".  I am currently in the process of searching for schools and I have been using CollegeRecon.com to assist me in my search for the college or university that best fits my needs and interests. After searching for schools on CollegeRecon, I came across CollegeName.\n\n";

      if (cannedMsg == 'APPLICATIONHELP') {
        messageToSend += "I am extremely interested in CollegeName and was wondering if there was someone either in the Veteran Affairs office or your department who could answer some questions I may have about the application process." + "\n\n";
      }
      if (cannedMsg == 'PHONECALL') {
        messageToSend += "I am very interested in what CollegeName has to offer, and I would love to speak with someone to learn more. Does CollegeName have a Veteran Affairs office on campus? Could you tell me what types of resources your campus makes available to individuals like myself? Any insight would be greatly appreciated." + "\n\n";
      }

      if (cannedMsg == 'GENERALQUESTIONS') {
        messageToSend += "I am very interested in what CollegeName has to offer, and I would love to speak with someone to learn more. Does CollegeName have a Veteran Affairs office on campus? Could you tell me what types of resources your campus makes available to individuals like myself? Any insight would be greatly appreciated." + "\n\n";
      }

      if (cannedMsg == 'NEXTSTEPS') {
        messageToSend += "CollegeName seems like a great fit and I am interested in learning more about your institution. Is there someone within admissions or your Veteran Affairs office that I can speak with over the phone?" + "\n\n";
      }

      messageToSend += "Thank you in advance for any help you can provide. I look forward to hearing back from you!" + "\n\n";
      messageToSend += "Best," + "\n";
      messageToSend += studentName;

      $('#student-message').empty();
      $('#student-message').val(messageToSend);
    }
  }

  reloadData() {

  }

  skipPhoneNumber() {
    this.checkPhone = "no";
    this.sendRequestInfoCollege();
    $("#phoneNumberMessageModal").modal('toggle');
  }

  async submitPhoneNumber() {
    const phone = document.getElementById("modalphone") as HTMLInputElement | null;

    if(!this.veteranPhone) {
      const phone = document.getElementById("modalphone") as HTMLInputElement | null;
      if(phone.value || this.veteranPhone){
        this.phoneErrorMessage = false;
        this.veteranPhone = phone.value;
        let phoneInfo = {
          phone: phone.value,
          studentId: this._parent.model.uuid
        }
        this.PhoneSuccessMessage = true;
        await this._services.post('/student/update/phonenumber', phoneInfo);
        this.checkPhone = "yes";
        this.saving = false;
        $("#phoneNumberMessageModal").modal('toggle');
        this.sendRequestInfoCollege();
      } else{
        this.phoneErrorMessage = true;
      }
    } else {
      this.checkPhone = "yes";
      this.saving = false;
      $("#phoneNumberMessageModal").modal('toggle');
      this.sendRequestInfoCollege();
    }
  }

  async sendRequestInfoCollege(){
    let sentColleges = [];
    if(this.checkPhone == "yes" || this.checkPhone == "all"){
      sentColleges = this.checkedColleges;
    }else{
      sentColleges = this.resultData
      .filter((school) => (this.checkedColleges.indexOf(school.collegeId.toString()) > -1 && school.phoneRequired == "no"))
      .map((school) => school.collegeId);
    }
    // console.log("CC:", sentColleges);
    this._parent.model.checkCollegeInfo = sentColleges.join(",");
    this.emailData = await this._services.post('/search/emaildata', this._parent.model);
    if(this.emailData[0]['collegeId']){
      $('#requestinfo').addClass('disabled');
      this.envelope = false;
      this.spinner = true;
      let firstname = this._parent.model.first_name;
      let lastname = this._parent.model.last_name;
      let response = "";
      let check = 0;
      let UnsendColl = "";
      for (var i = 0; i < this.emailData.length; i++) {
        let sentCollegeId = this.emailData[i]['collegeId'];
        this.cname = this.emailData[i]['college_name'];
        let vetinfo = await this._services.get('/student/messageinfo/' + this._parent.model.uuid);

        let collegeadminUrl = this.serverUrl + "/login?cadmin=" + this.encrypt.encodeBase64("cid:"+sentCollegeId);
        let messagedata = "";
        var branch = "";
        var rank = "";
        var branchAndRank = "";
        if (vetinfo.branchName != "" && vetinfo.branchName != null) {
          branch = vetinfo.branchName;
        }

        if (vetinfo.rankName != "" && vetinfo.rankName != null) {
          rank = vetinfo.rankName;
        }
        messagedata += "<b>Name</b>: " + firstname + " " + lastname + "\n";
        let emailData = vetinfo.email.split('@');
        if(this.emailData[i]['access_level'] == 'Patriot'){
          messagedata += "<b>Email</b>: " + vetinfo.email + "\n";
        }else{
          messagedata += "<b>Email</b>: " + emailData[0].slice(0, 1) + "#####@" + emailData[1] + "\n";
        }

        if(this.emailData[i]['access_level'] == 'Patriot'){
          if(vetinfo.zipCode){
            messagedata += "<b>Zip Code</b>: " + vetinfo.zipCode + "\n";
          }
          if(vetinfo.phoneNumber && vetinfo.checkPhoneNumber == 'yes'){
            messagedata += "<b>Phone</b>: " + vetinfo.phoneNumber + "\n";
          }
        }else{
          messagedata += "<i>*As a non-partner school, you are unable to view user contact information. You may reply by logging into your CollegeRecon profile or by replying directly to this email from <a href='mailto:members@collegerecon.com'>members@collegerecon.com</a> and it will be sent to the interested candidate. </i>\n\n";
        }

        messagedata += "<b>State</b>: " + vetinfo.state + "\n";
        if (vetinfo.militaryStatus) {
          messagedata += "<b>Military Status</b>: " + vetinfo.militaryStatus + "\n";
        }
        if (branch) {
          messagedata += "<b>Branch</b>: " + branch + "\n";
        }
        if (rank) {
          messagedata += "<b>Rank</b>: " + rank + "\n";
        }

        if(this.emailData[i]['access_level'] == 'Patriot' && vetinfo.academicLevel){
          messagedata += "<b>Academic Level</b>: " + vetinfo.academicLevel + "\n";
        }
        
        if(this.sbucketLists.length > 0){
          messagedata += "<b>Academic Interest(s)</b>:\n";
          for(let i=0;i<this.sbucketLists.length;i++){
            messagedata += this.sbucketLists[i].title+ "\n";
          }
        }
        
        messagedata += "<b>Register Date</b>: " + moment(vetinfo.dateRegister).format('MM/DD/YYYY') + "\n";
        if(this.emailData[i]['access_level'] == 'Patriot'){
          messagedata += "\n\n<i>For more information, please click <a href='"+collegeadminUrl+"'><b>here</b></a> to login to your account. \n\nIf you need assistance, please contact your primary point of contact at CollegeRecon, submit requests to <a href='mailto:information@hfalliance.com'>information@hfalliance.com</a> or call 414-350-6638.</i>\n\n\n";
        }else{
          messagedata += "\n\n<i>For more information, please click <a href='"+collegeadminUrl+"'><b>here</b></a> to login to your free account. \n\nIf you do not already have a login or this is your first message from CollegeRecon, please contact us at <a href='mailto:information@hfalliance.com'>information@hfalliance.com</a> or 414-350-6638.</i>\n\n";
          messagedata += "<b>About this message:</b>\n";
          messagedata += "You are receiving this message as a notice that a prospective military-connected student is interested in learning more about your school.\n\n";
          messagedata += "<b>About CollegeRecon:</b>\n";
          messagedata += "CollegeRecon is the largest, digital college resource built specifically for the military. CollegeRecon provides schools the opportunity to increase their exposure and branding within the military community.\n\n";
          messagedata += "To learn more please visit <a target='_blank' href='https://collegerecon.com/partnerships/'>here</a>.\n\n\n";
        }

        messagedata += "Thanks!" + "\n\n";
        messagedata += "<b>Team CollegeRecon</b>";
        let secondaryUrl = "";
        let currentUrl = window.location.href;
        let urlData = currentUrl.split("/");
        if (localStorage.getItem('NewUserRegister') == "true") {
          if (urlData[3]) {
            secondaryUrl = "/register/request-info/" + urlData[3];
          } else {
            secondaryUrl = "/register/request-info";
          }
        } else if (urlData[3]) {
          secondaryUrl = "/request-info/" + urlData[3];
        } else {
          secondaryUrl = "/request-info";
        }
        if(this.snhuChecked && sentCollegeId == 3755) {
          this.formData.advertiser_name = 'Southern New Hampshire University (SNHU)'
        }
        let emaildata = {
          'studentId': this._parent.model.uuid,
          'collegeId': sentCollegeId,
          'messageId': "",
          'replyMessage': messagedata,
          'collegeEmail': this.emailData[i]['contact_email'],
          'attachment': "",
          'recipient': "COLLEGE",
          'responder': "USER",
          'primarySource': "program matcher",
          'secondarySource': secondaryUrl,
          'type': "connect",
          'formData': this.formData.trustedform_cert_url && this.formData.advertiser_name != '' ? this.formData : ''

        }
        
        response = await this._services.post('/student/replymessage', emaildata);
        if (response == "success") {
          check++;
          // Update users matched data
          let updateData = {
            "studentId": this._parent.model.uuid,
            "collegeId": sentCollegeId
          }
          await this._services.post('/flow/match/emailsent/collegelist', updateData);
        } else {
          UnsendColl = UnsendColl + this.cname + ",";
        }
      }

      if (check == this.emailData.length) {
        window.location.href = this.serverUrl + "/login?uid=" + this._parent.model.uuid;
      } else {
        let unmessage = "Unable to send message to following colleges </br> " + UnsendColl.slice(0, -1);
        let unemaildata = {
          'to': "garrett@hfalliance.com",
          'subject': "Unable to send Message from Search Collegerecon",
          'message': unmessage
        }
        await this._services.post('/search/send/message', unemaildata);
        window.location.href = this.serverUrl + "/login?uid=" + this._parent.model.uuid;
      }
    }else{
      alert("Please check at least one school or click Skip for Now.")
    }
  }

  private loadTrustedForm(): void {
    const tf = document.createElement('script');
    tf.type = 'text/javascript';
    tf.async = true;
    tf.src = (`https:` === document.location.protocol ? 'https' : 'http') +
      '://api.trustedform.com/trustedform.js?field=xxTrustedFormCertUrl&ping_field=xxTrustedFormPingUrl&use_tagged_consent=true&l=' +
      new Date().getTime() + Math.random();

    tf.onload = () => {
      this.captureTrustedFormData();
    };

    tf.onerror = () => {
      console.error('Error loading TrustedForm script');
    };

    document.head.appendChild(tf);
  }

  private captureTrustedFormData(): void {
    const maxRetries = 10;
    let retries = 0;

    const interval = setInterval(() => {
      const certField = document.querySelector(
        'input[name="xxTrustedFormCertUrl"]'
      ) as HTMLInputElement;
      const pingField = document.querySelector(
        'input[name="xxTrustedFormPingUrl"]'
      ) as HTMLInputElement;

      if (certField && certField.value) {
        this.formData.trustedform_cert_url = certField.value;
      }

      if (pingField && pingField.value) {
        this.formData.trustedform_ping_url = pingField.value;
      }

      if ((certField && certField.value) && (pingField && pingField.value)) {
        clearInterval(interval);
      } else if (retries >= maxRetries) {
        console.error('Unable to capture TrustedForm data.');
        clearInterval(interval);
      }

      retries++;
    }, 500);
  }


}


// WEBPACK FOOTER //
// ./src/app/components/pworkflow/result/result.component.ts